/* eslint-disable eag/match-named-export */
/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum Type {
  EVENT = 'EVENT',
  READ = 'READ',
  TYPING = 'TYPING',
}

export type Notification = {
  __typename: 'Notification';
  conversationId: string;
  id: string;
  tenantId: string;
  type: Type;
  userId: string;
};

export type SendEventMutationVariables = {
  conversationId: string;
  id: string;
  tenantId: string;
  type: Type;
  userId: string;
};

export type SendEventMutation = {
  sendEvent?: {
    __typename: 'Notification';
    conversationId: string;
    id: string;
    tenantId: string;
    type: Type;
    userId: string;
  } | null;
};

export type HealthCheckQueryVariables = {};

export type HealthCheckQuery = {
  healthCheck?: boolean | null;
};

export type OnSendEventSubscriptionVariables = {
  conversationId: string;
};

export type OnSendEventSubscription = {
  onSendEvent?: {
    __typename: 'Notification';
    conversationId: string;
    id: string;
    tenantId: string;
    type: Type;
    userId: string;
  } | null;
};
